import { render, staticRenderFns } from "./videoshow.vue?vue&type=template&id=5417122e&scoped=true&"
import script from "./videoshow.vue?vue&type=script&lang=js&"
export * from "./videoshow.vue?vue&type=script&lang=js&"
import style0 from "./videoshow.vue?vue&type=style&index=0&id=5417122e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5417122e",
  null
  
)

export default component.exports